/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHandlerConfigurationUpdateRequest extends models.BackgroundJobHandlerConfigurationRequest {
    getFixupPrototypeFunction() { return BackgroundJobHandlerConfigurationUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHandlerConfigurationUpdateRequest>): BackgroundJobHandlerConfigurationUpdateRequest {
        let obj = Object.assign(new BackgroundJobHandlerConfigurationUpdateRequest(), model);
        BackgroundJobHandlerConfigurationUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHandlerConfigurationUpdateRequest>): BackgroundJobHandlerConfigurationUpdateRequest {
        if (!model) return null;
        return BackgroundJobHandlerConfigurationUpdateRequest.newInstance(<BackgroundJobHandlerConfigurationUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHandlerConfigurationUpdateRequest) {
        if (!obj) return;

        models.BackgroundJobHandlerConfigurationUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHandlerConfigurationUpdateRequest): boolean {
        if (models.BackgroundJobHandlerConfigurationRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobHandlerConfigurationUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.config) {
            models.BackgroundJobHandlerConfiguration.fixupPrototype(this.config);
        }
    }

    /**
     * New configuration
     */
    config: models.BackgroundJobHandlerConfiguration;

}
